<template>
  <div>
    Applications

    <portal 
      v-if="componentVisible"
      to="competition-edit-tertiary"
    >
      <ul class="list-reset flex">
        <li class="mr-6">
          <button class="block py-4 text-black no-underline outline-none">Overview</button>
        </li>
        <li class="mr-6">
          <button class="block py-4 text-black no-underline opacity-50 hover:opacity-100 transition-all transition-normal outline-none">Form</button>
        </li>
      </ul>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'CompetitionEditApplications',
  data() {
    return {
      componentVisible: false
    }
  },
  activated() {
    this.componentVisible = true
  },
  deactivated() {
    this.componentVisible = false
  }
}
</script>
